import { SKIP_FORBIDDEN } from './httpConfig';

export class FormDeliveryRequestApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFormDeliveryRequests({ applicationId }) {
    return this.#http.get('/api/FormDeliveryRequests', {
      params: { applicationId, includeIsFenced: true },
    });
  }

  async getRecipientSignerView({ formDeliveryRequestId, recipientRequestId }) {
    return this.#http.get(
      `/api/FormDeliveryRequests/${formDeliveryRequestId}/recipientRequests/${recipientRequestId}/signer-view`,
      { responseType: 'blob', ...SKIP_FORBIDDEN },
    );
  }

  async reissueRecipientSigningLink({ formDeliveryRequestId, recipientRequestId }) {
    return this.#http.post(
      `/api/FormDeliveryRequests/${formDeliveryRequestId}/recipientRequests/${recipientRequestId}/reissue-link`,
      {},
    );
  }

  async correctRecipientEmail({ formDeliveryRequestId, recipientRequestId, email, resend = true }) {
    return this.#http.put(
      `/api/FormDeliveryRequests/${formDeliveryRequestId}/recipientRequests/${recipientRequestId}/email`,
      { email, resend },
    );
  }

  async switchRecipientAuthorization({
    formDeliveryRequestId,
    recipientRequestId,
    type,
    ssnLast4 = null,
    zipCode = null,
  }) {
    return this.#http.put(
      `/api/FormDeliveryRequests/${formDeliveryRequestId}/recipientRequests/${recipientRequestId}/authorization`,
      { type, ssnLast4, zipCode },
    );
  }

  async recordRecipientMailedDelivery({ formDeliveryRequestId, recipientRequestId, mailedDate }) {
    return this.#http.put(
      `/api/FormDeliveryRequests/${formDeliveryRequestId}/recipientRequests/${recipientRequestId}/mailed-delivery`,
      { mailedDate },
    );
  }

  async correctGeneratedOutsideDates({ formDeliveryRequestId, recipients }) {
    return this.#http.put(`/api/FormDeliveryRequests/${formDeliveryRequestId}`, {
      type: 'GeneratedOutside',
      requestId: formDeliveryRequestId,
      recipients: recipients.map(({ recipientRequestId, sentDate, eSignedDate }) => ({
        recipientRequestId,
        sentDate,
        eSignedDate,
      })),
    });
  }
}
